import Base, { baseInit } from './base';
import { File } from './file';
class CompanionAsset extends Base {
  _uuid = null; // String - internal field used for referencing creatives
  id = null; // Integer
  assetType = null;
  images = []; // [ File{} ]
  location= null;
  landingPageURL=null;
  adTagCode=null;
  constructor(data) {
    super(data);
    baseInit(this, data, true);
    if (this.images === null) {
      this.images = [];
    } else {
      this.images = this.images.map((f) => new File(f));
    }
  }


}

export { CompanionAsset };
